import axios from "axios";
import useConfig from "../config";
// const API_URL = "https://localhost.letscreate.zone:3010/api"; // "https://server-warehouse-server-staging.letscreate.zone/api"; //
import regeneratorRuntime from "regenerator-runtime"; //Needed for node 12 / bigcommerce / stencil for async functions otherwise fails - dont know why
import useSettings from "components/ConfiguratorApp/hooks/useSettings";

function useAPI() {
  const settings = useSettings();

  const filterQuery = settings.filterQuery;

  const { API_URL } = useConfig();

  const get = async (url, config, absolute) => {
    if (!absolute) {
      //So absolute urls can be passed
      url = API_URL + url;
    }
    config = config || {};

    if (filterQuery) {
      if (url.indexOf("?") > -1) {
        url = url + "&" + filterQuery;
      } else {
        url = url + "?" + filterQuery;
      }
    }

    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.get(url, config);
      return response.data;
    } catch (e) {
      return errorHandle(e);
    } finally {
      console.log("Done with API Call");
    }
  };
  const post = async (url, data, config, absolute) => {
    if (!absolute) {
      //So absolute urls can be passed
      url = API_URL + url;
    }
    config = config || {};
    data = data || {};
    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.post(url, data, config);
      return response.data;
    } catch (e) {
      errorHandle(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  const del = async (url, config, absolute) => {
    if (!absolute) {
      //So absolute urls can be passed
      url = API_URL + url;
    }
    config = config || {};

    try {
      console.log("Call url", url, "with config", config);
      let response = await axios.delete(url, config);
      return response.data;
    } catch (e) {
      return errorHandle(e);
    } finally {
      console.log("Done with API Call");
    }
  };

  const errorHandle = (e) => {
    console.error("e", e);
    return e;
  };

  return {
    API: {
      get,
      post,
      del,
    },
  };
}

export default useAPI;
